import { apiRequest } from '@/core';
import { type EditIncidentPayload } from '@/slices/events/types';

export const editIncidentRequest = async (incident: EditIncidentPayload) =>
  apiRequest<void>({
    endpoint: `api/incidents`,
    method: 'PUT',
    body: incident,
  });
